import React from "react";
import "./Product.css";
import uncategory from "./image/Product/Uncategorized.png";
import auto from "./image/Product/Automobile.jpg";
import boiler from "./image/Product/Boiler.jpg";
import cement from "./image/Product/cement.jpg";
import chemical from "./image/Product/Chemical.jpg";
import other from "./image/Product/other.jpg";
import paper from "./image/Product/paper.jpg";
import refractory from "./image/Product/refractory.jpg";
import solvent from "./image/Product/solvent.jpg";
import steel from "./image/Product/steel.jpg";
import sugar from "./image/Product/sugar.jpg";
import transmission from "./image/Product/transmission.jpg";
import { Link } from "react-router-dom";

const Product = () => {
  return (
    <div>
      <div className="prop">
        <p className="p">Products</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: > Products</p> */}
        </div>
      </div>

      <div className="product-one">
        <div class="product-container">
          <div class="text-content">
            <Link to="/product-uncategory">
              <img src={uncategory} alt="uncategory" />
            </Link>
            <h3>Uncategory</h3>
            <p>4 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-automobile">
              <img src={auto} alt="Automobile" />
            </Link>
            <h3>Automobile</h3>
            <p>6 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-boiler">
              <img src={boiler} alt="boiler" />
            </Link>
            <h3>Boiler And Thermal Power Plant</h3>
            <p>4 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-cement">
              <img src={cement} alt="cement" />
            </Link>
            <h3>Cement Sector</h3>
            <p>13 items</p>
          </div>
        </div>
      </div>

      <div className="product-one">
        <div class="product-container">
          <div class="text-content">
            <Link to="/product-chemical">
              <img src={chemical} alt="chemical" />
            </Link>
            <h3>Chemical And Fertilizer Industry</h3>
            <p>3 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-other">
              <img src={other} alt="other" />
            </Link>
            <h3>Other Industry</h3>
            <p>5 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-paper">
              <img src={paper} alt="paper" />
            </Link>
            <h3>Paper Industry</h3>
            <p>4 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-refractory">
              <img src={refractory} alt="refractory" />
            </Link>
            <h3>Refractory Industry</h3>
            <p>4 items</p>
          </div>
        </div>
      </div>

      <div className="product-one">
        <div class="product-container">
          <div class="text-content">
            <Link to="/product-solvent">
              <img src={solvent} alt="solvent" />
            </Link>
            <h3>Solvent Plant</h3>
            <p>3 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-steel">
              <img src={steel} alt="steel" />
            </Link>
            <h3>Steel Industry</h3>
            <p>8 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-sugar">
              <img src={sugar} alt="sugar" />
            </Link>
            <h3>Sugar Factory</h3>
            <p>10 items</p>
          </div>
        </div>

        <div class="product-container">
          <div class="text-content">
            <Link to="/product-transmission">
              <img src={transmission} alt="transmission" />
            </Link>
            <h3>Transmission Chain</h3>
            <p>1 items</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
